var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',_vm._l((_vm.instructions),function(instruction,i){return _c('property-instruction',{key:i,attrs:{"instruction":instruction},scopedSlots:_vm._u([{key:"list-item-content",fn:function(ref){
var instruction = ref.instruction;
return [_vm._t("list-item-content",null,null,{ instruction: instruction })]}}],null,true)})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }